import React from 'react';
import VennITP from "./VennITP";

const PageHeader = ({ title }) => {
	return (
		<div className="page-header">
			<p className="title">{title}</p>
		</div>
)
	;
};

export default PageHeader;
